import React, { useState } from 'react';

function Contact() {
  const [submitting, setSubmitting] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmitting(true);

    try {
      const form = e.target;
      const formData = new FormData(form);
      const response = await fetch("https://formspree.io/f/mgvvpvog", {
        method: "POST",
        body: formData,
        headers: {
          'Accept': 'application/json'
        },
      });

      if (response.ok) {
        form.reset();
        alert("Message sent successfully! We'll get back to you soon.");
      } else {
        throw new Error('Failed to send message');
      }
    } catch (error) {
      console.error("Form submission error:", error);
      alert("Something went wrong. Please try again later.");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <section className="contact section-padding" data-scroll-index="6">
      <div className="container">
        <div className="row">
          <div className="col-lg-4 valign">
            <div className="sec-head info-box full-width md-mb80">
              <div className="phone fz-30 fw-600 underline main-color">
                <p>Bangalore:</p> <a href="#0">7090048025</a>
                <p>Mysore: </p><a href="#0">7892590578</a>
              </div>
              <div className="morinfo mt-50 pb-30 bord-thin-bottom">
                <h6 className="mb-15">Address</h6>
                <p>No. 40, Govinda Gopala Krupa, D&apos;souza Layout, Banashankari 3rd Stage, Hosakerehalli, Bengaluru, Karnataka 560085</p>
              </div>
              <div className="morinfo mt-30 pb-30 bord-thin-bottom">
                <h6 className="mb-15">Email</h6>
                <p>info@stepinhomeservices.in</p>
              </div>
              <div className="social-icon-circle mt-50">
                <a href="https://www.facebook.com/share/1DTALczUSM/"><i className="fab fa-facebook-f"></i></a>
                <a href="https://www.youtube.com/@stepinhomeservices"><i className="fab fa-youtube"></i></a>
                <a href="https://www.instagram.com/stepinhomeservices?utm_source=qr&igsh=MWNwdHc3eDI1NWQwNg=="><i className="fab fa-instagram"></i></a>
              </div>
            </div>
          </div>
          <div className="col-lg-7 offset-lg-1 valign">
            <div className="full-width">
              <div className="sec-head mb-50">
                <h6 className="sub-title main-color mb-15">Let&apos;s Chat</h6>
                <h3 className="text-u ls1">Send a <span className="fw-200">message</span></h3>
              </div>
              <form 
                id="contact-form" 
                className="form2" 
                onSubmit={handleSubmit}
              >
                <div className="controls row">
                  <div className="col-lg-6">
                    <div className="form-group mb-30">
                      <input
                        id="form_name"
                        type="text"
                        name="name"
                        placeholder="Name"
                        required="required"
                      />
                    </div>
                  </div>

                  <div className="col-lg-6">
                    <div className="form-group mb-30">
                      <input
                        id="form_email"
                        type="email"
                        name="email"
                        placeholder="Email"
                        required="required"
                      />
                    </div>
                  </div>

                  <div className="col-12">
                    <div className="form-group mb-30">
                      <input
                        id="form_subject"
                        type="text"
                        name="subject"
                        placeholder="Subject"
                      />
                    </div>
                  </div>

                  <div className="col-lg-6">
                    <div className="form-group mb-30">
                      <select
                        id="form_location"
                        name="location"
                        required="required"
                        className="custom-select"
                      >
                        <option value="" disabled selected>Select Location</option>
                        <option value="Bengaluru">Bengaluru</option>
                        <option value="Mysore">Mysore</option>
                      </select>
                    </div>
                  </div>
                  <div className="col-lg-6">
                    <div className="form-group mb-30">
                      <select
                        id="form_service"
                        name="service"
                        required="required"
                        className="custom-select"
                      >
                        <option value="" disabled selected>Select Service</option>
                        <option value="Cleaning">Cleaning</option>
                        <option value="Painting">Painting</option>
                        <option value="PestControl">Pest Control</option>
                        <option value="RR">Renovation & Remodeling</option>
                        <option value="MarblePolishing">Marble Polishing</option>
                        <option value="Sanitization">Sanitization</option>
                      </select>
                    </div>
                  </div>

                  <div className="col-12">
                    <div className="form-group">
                      <textarea
                        id="form_message"
                        name="message"
                        placeholder="Message"
                        rows="4"
                        required="required"
                      ></textarea>
                    </div>
                    <div className="mt-30">
                      <button
                        type="submit"
                        className="butn butn-full butn-bord radius-30"
                        disabled={submitting}
                      >
                        <span className="text">
                          {submitting ? 'Sending...' : "Let's Talk"}
                        </span>
                      </button>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Contact;